import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { createMuiTheme } from "@material-ui/core/styles";
import { yellow, purple } from "@material-ui/core/colors";
import store from "./store/store";
import { routes } from "./routes";

/**
 * Main App layout.
 * Adds store, router and layouts from ./layouts folder.
 */
function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          {Object.entries(routes).reverse().map((prop, key) => {
            return (
              <Route
                path={prop[0]}
                component={prop[1].component}
                key={key}
              />
            )
          })}
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export const theme = createMuiTheme({
  palette: {
    primary: yellow,
    secondary: purple
  }
});

export default App;
